import React, { useCallback, Fragment, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import useSWRRequest from "../../../core/useSWRRequest";
import Request from "../../../core/requests";
import { useDispatch } from "react-redux";
import { openSnackbar } from "store/slices/snackbar";
import CardFormComponent from "components/common/card/CardForm.component";
import { SubmitButton } from "components/form";
import { useTranslation } from "react-i18next";

const RegistrationConfirmContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  const { data, error } = useSWRRequest(Request.users.registrationConfirm, {
    t: token,
  });

  const onClick = useCallback(() => {
    navigate("/login");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (error) {
      dispatch(
        openSnackbar({
          open: true,
          message: error.response?.data?.message ? error.response.data.message : "Errore",

          variant: "alert",
          alert: {
            color: "error",
          },
          close: false,
        })
      );
    }
    // eslint-disable-next-line
  }, [error]);

  return (
    <Fragment>
      <CardFormComponent
        title={error ? t('An Error has occurred') : t('Confirm registration')}
        subTitle={
          error
            ? t("Failed to complete registration, invalid token!")
            : data && data?.message
        }
      >
        <SubmitButton label="Login" onClick={onClick} />
      </CardFormComponent>
    </Fragment>
  );
};

export default RegistrationConfirmContainer;
